import { render, staticRenderFns } from "./dashboard-today.vue?vue&type=template&id=1b487691&scoped=true"
import script from "./dashboard-today.vue?vue&type=script&lang=js"
export * from "./dashboard-today.vue?vue&type=script&lang=js"
import style0 from "./dashboard-today.vue?vue&type=style&index=0&id=1b487691&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b487691",
  null
  
)

export default component.exports